<template>
  <el-dialog title="订单详情"
             :visible.sync="visible"
             width="40%"
             :append-to-body="true"
             @open="handleOpen"
             @before-close="handleClose">
    <el-row>
      <el-form :model="lessonOrder">
        <el-col :span="12">
          <el-form-item label="订单编号：">
            {{lessonOrder.orderNumber}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单来源：">
            {{lessonOrder.orderSource}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="课程名称：">
            {{lessonOrder.lessonName}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="医生姓名：">
            {{lessonOrder.doctorName}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单单价：">
            {{lessonOrder.orderPrice}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单人数：">
            {{lessonOrder.doctorCount}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单金额：">
            {{lessonOrder.orderMoney}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余可用次数：">
            {{lessonOrder.doctorCountRemain}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款状态：">
            {{lessonOrder.moneyStatus}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单生效日期：">
            {{lessonOrder.beginDate}}
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <h4 v-if="selRow.length > 0" :span="12">
      领用情况：
    </h4>
    <el-table v-if="selRow.length > 0" size="small" :data="selRow"  border style="width: 100%">
      <el-table-column prop="hospitalName" align="center" label="所属医院" min-width="20" />
      <el-table-column prop="orderCode" align="center" label="订单识别码" min-width="20" />
      <el-table-column prop="doctorName" align="center" label="领用医生" min-width="20"/>
      <el-table-column prop="useTime" align="center" label="领用时间" width="150"/>
    </el-table>
  </el-dialog>
</template>

<script>
import {commonAttachMixin} from "../../../../utils/commonAttachMixin";

export default {
  name: "lessonOrderForm",
  mixins: [commonAttachMixin],
  props:['selRow', 'lessonOrder'],
  data() {
    return {
      form : {},
      visible: false,
    }
  },
  methods:{
    async handleOpen() {
    },
    handleClose() {
    }
  }
}
</script>

<style scoped>

</style>